// utils/serverTime.ts
/**
 * Server time synchronization using Firebase's .info/serverTimeOffset
 *
 * Firebase provides the offset between the client's clock and the server's clock.
 * By using this offset, all clients calculate elapsed time relative to the same
 * server reference, regardless of local clock drift.
 */
import { ref, onValue } from 'firebase/database';
import { db } from '../config/firebase';

let serverTimeOffset = 0;
let initialized = false;

/**
 * Initialize the server time offset listener.
 * Called automatically on first import, but safe to call multiple times.
 */
export function initServerTimeSync(): void {
  if (initialized) return;
  initialized = true;

  const offsetRef = ref(db, '.info/serverTimeOffset');
  onValue(offsetRef, (snapshot) => {
    serverTimeOffset = snapshot.val() || 0;
  });
}

/**
 * Get the current server-adjusted time.
 * Equivalent to Date.now() but corrected for client clock drift.
 */
export function getServerTime(): number {
  return Date.now() + serverTimeOffset;
}

// Auto-initialize on import
initServerTimeSync();
